<template>
    <v-dialog v-model="dialog" width="510px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" small icon class="mx-2" color="secondary">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>delete</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                Do you want to delete the insight of the segment <span class="secondary--text">{{ this.insight.segment?.name }}</span>?
            </v-card-title>
            <v-divider />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    No
                </v-btn>
                <v-btn color="error" text class="text-capitalize" :disabled="Boolean(error)" @click="deleteInsight">
                    Yes</v-btn>
            </v-card-actions>
        </v-card>
        <div v-else class="text-xs-center">
            <loader></loader>
        </div>
    </v-dialog>
</template>

<script>
import Loader from '../../../layouts/Loader.vue'

export default {
    name: 'Delete_Insight',
    props: ['insight'],
    data() {
        return {
            dialog: false,
            error: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        async deleteInsight() {
            if (this.insight && this.insight.id) {
                const id = this.insight.id
                try {
                    await this.$store.dispatch('deleteInsight', id);
                }
                catch (error) {
                    console.log(error.message)
                }
            }
        }
    },
    components: { Loader }
}
</script>